interface RecordCountProps {
  filtered: number;
  total: number;
  entity: string;
}

export function RecordCount({ filtered, total, entity }: RecordCountProps) {
  return (
    <p className="text-xs text-muted-foreground text-center">
      Showing {filtered} of {total} {entity}
    </p>
  );
}
